import React, {useEffect, useRef, useState} from 'react';
import {legacyPlaceFromGooglePlace, matchUserToLocation, parseAddressComponents} from "btdt/shared";
import LocationContact from "btdt/react/LocationContact";

export default function AddressStep({animating, app, handleLoading, needContactHelp, chosenLocation, place, handleLocationMatches, handleLocationChange, handlePlaceChange, handleNextStep}) {

    const [validPlace, setValidPlace] = useState(false);
    const autocompleteContainer = useRef(null);

    useEffect(() => {
        const container = autocompleteContainer.current;
        if (!container) return;

        const ac = new app.google.maps.places.PlaceAutocompleteElement({
            includedRegionCodes: ['us', 'ca'],
            noClearButton: true,
            noInputIcon: true,
        });
        ac.placeholder = 'Begin typing your address';
        //ac.className = 'search-input';

        const onSelect = async ({placePrediction}) => {
            const selectedPlace = placePrediction.toPlace();
            await selectedPlace.fetchFields({
                fields: ['addressComponents', 'formattedAddress', 'location'],
            });
            handlePlaceChange(JSON.parse(JSON.stringify(legacyPlaceFromGooglePlace(selectedPlace))));
            handleLocationChange(null);
        };

        ac.addEventListener('gmp-select', onSelect);
        container.appendChild(ac);

        return () => {
            ac.removeEventListener('gmp-select', onSelect);
            ac.remove();
        };
    }, [app]);

    useEffect(() => {

        if (place?.address_components) {
            let {city, region, postalCode, country} = parseAddressComponents(place.address_components)
            const isValid = Boolean(city && region && postalCode && country)
            setValidPlace(isValid);

            const matchLocation = async () => {
                handleLoading(true)

                let matches

                const coords = JSON.parse(JSON.stringify({
                    lat: place?.geometry?.location?.lat,
                    lng: place?.geometry?.location?.lng
                }))

                matches = await matchUserToLocation({city, postalCode, country, coords}, app.locations, app.google)
                if (matches.length > 1) {
                    matches = matches.filter(m => parseFloat(m.distance) <= 80.5)
                }

                handleLoading(false)

                return matches.slice(0, 2)
            }

            if (!chosenLocation && isValid) {
                matchLocation().then(locations => {
                    handleLocationMatches(locations)
                    if (locations.length === 1) {
                        handleLocationChange(locations[0])
                    }
                })
            }
        } else {
            setValidPlace(false);
        }

    }, [place])

    useEffect(() => {
        handleLocationMatches(null)
        if (place && !chosenLocation) {
            handlePlaceChange(null);
        }
    }, []);

    return (
        <div className={"container mx-auto px-4 lg:px-8"}>
            <div className={"grid grid-cols-1 lg:grid-cols-12 gap-x-8"}>
                <div className={"lg:col-span-8 lg:col-start-3"}>
                    {needContactHelp ? (
                        <>
                            <div className={"large-p mb-6"}>
                                Can we have your address? This helps us direct your message to the nearest Bin There Dump That franchise.
                            </div>
                            {place && validPlace && (
                                <div className={"mb-4"}>
                                    Your address is currently set as <strong>{place.formatted_address}</strong>. If
                                    this is not correct, please enter the correct address below.
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <div className={"large-p mb-6"}>
                                Can we have the address of where the dumpster will be delivered? This helps us
                                get you accurate sizing info.
                            </div>
                            {place && validPlace && (
                                <div className={"mb-4"}>
                                    Your delivery address is currently set as <strong>{place.formatted_address}</strong>. If
                                    this is not correct, please enter the correct address below.
                                </div>
                            )}
                        </>
                    )}
                    {place && !validPlace && (
                        <div className={"mb-4"}>
                            Please select a street address from the dropdown.
                        </div>
                    )}
                    <div className={"mb-6"} ref={autocompleteContainer}/>
                    <button className={"btn"} disabled={animating || !validPlace} onClick={handleNextStep}>
                        {!needContactHelp ? 'Next Step →' : 'Get in touch'}
                    </button>
                    {chosenLocation && (
                        <div className={"mt-6"}>
                            <LocationContact location={chosenLocation}/>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}